import { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import MiniBundle from '../bundles/MiniBundle';
import { downloadPlantillaFile } from './plantillaDownload';

function PlantillaRow({
    plantilla,
    bundlesUsing,
    socket,
    sortBy,
    folderName,
    onMoveToFolder,
    userId,
}) {
    const [showActions, setShowActions] = useState(false);
    const [showBlockedModal, setShowBlockedModal] = useState(false);
    const actionsRef = useRef(null);

    useEffect(() => {
        if (!showActions) return;
        const handleClick = (e) => {
            if (actionsRef.current && !actionsRef.current.contains(e.target)) {
                setShowActions(false);
            }
        };
        document.addEventListener('mousedown', handleClick);
        return () => document.removeEventListener('mousedown', handleClick);
    }, [showActions]);

    const handleRename = () => {
        setShowActions(false);
        const newName = window.prompt('Quin nom vols posar a la plantilla?', plantilla);
        if (newName && newName !== plantilla) socket.emit('.rename_plantilla', plantilla, newName);
    };

    const handleDuplicate = () => {
        setShowActions(false);
        const newName = window.prompt('Quin nom vols posar a la nova plantilla?', plantilla);
        if (newName) socket.emit('.duplicate_plantilla', plantilla, newName);
    };

    const handleDelete = () => {
        setShowActions(false);
        if (bundlesUsing.length > 0) {
            setShowBlockedModal(true);
            return;
        }
        const confirmed = window.confirm(`Eliminar la plantilla ${plantilla}? Es guardarà en un backup.`);
        if (confirmed) socket.emit('.delete_plantilla', plantilla, userId);
    };

    const downloadFile = (type) => {
        setShowActions(false);
        downloadPlantillaFile(plantilla, type);
    };

    return (
        <tr>
            {/* Editar */}
            <td className="editor-actions-cell">
                <button
                    className="editor-edit-btn"
                    onClick={() => window.location.href = `/editor/${plantilla}`}
                    title="Edita plantilla"
                >
                    &#10021;
                </button>
            </td>

            {/* Nom */}
            <td className={sortBy === 'nom' ? 'sorted-column' : ''} style={{ whiteSpace: 'nowrap' }}>
                {plantilla}
            </td>

            {/* Usada a */}
            <td style={{ maxWidth: 600 }}>
                <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                    {bundlesUsing.length > 0 ? (
                        bundlesUsing
                            .sort((a, b) => a.nom.localeCompare(b.nom))
                            .map(bundle => (
                                <MiniBundle key={bundle.id} bundle={bundle} part={bundle.part} />
                            ))
                    ) : (
                        <span style={{ color: '#d1d5db', fontSize: '0.82rem', fontStyle: 'italic' }}>—</span>
                    )}
                </div>
            </td>

            {/* Dins carpeta */}
            <td style={{ whiteSpace: 'nowrap' }}>
                {folderName ? (
                    <span style={{
                        display: 'inline-block',
                        padding: '2px 10px',
                        borderRadius: 12,
                        backgroundColor: '#f3f4f6',
                        color: '#6b7280',
                        fontSize: '0.82rem',
                    }}>
                        {folderName}
                    </span>
                ) : (
                    <span style={{ color: '#d1d5db', fontSize: '0.82rem', fontStyle: 'italic' }}>—</span>
                )}
            </td>

            {/* Accions */}
            <td className="editor-actions-cell" style={{ position: 'relative' }}>
                <button className="editor-more-btn" onClick={() => setShowActions(!showActions)} title="Accions">
                    &#8942;
                </button>
                {showActions ? (
                    <div ref={actionsRef} className="editor-actions-popover">
                        <button onClick={handleRename}>
                            Renombrar
                        </button>
                        <button onClick={handleDuplicate}>
                            Duplicar
                        </button>
                        <div className="popover-divider" />
                        <button onClick={() => downloadFile('aleta')}>
                            Descarrega .aleta
                        </button>
                        <button onClick={() => downloadFile('svg')}>
                            Descarrega SVG
                        </button>
                        <div className="popover-divider" />
                        <button onClick={() => {
                            setShowActions(false);
                            onMoveToFolder(plantilla);
                        }}>
                            Moure a carpeta...
                        </button>
                        <div className="popover-divider" />
                        <button className="danger" onClick={handleDelete}>
                            Eliminar
                        </button>
                    </div>
                ) : null}
            </td>
            {showBlockedModal ? createPortal(
                <div className="editor-modal-overlay" onClick={() => setShowBlockedModal(false)}>
                    <div className="editor-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="editor-modal-header">
                            <h3>No es pot eliminar</h3>
                            <button onClick={() => setShowBlockedModal(false)}>&times;</button>
                        </div>
                        <div className="editor-modal-body">
                            <p style={{ margin: '0 0 12px', color: '#374151' }}>
                                La plantilla <strong>{plantilla}</strong> s'utilitza a {bundlesUsing.length === 1 ? 'la següent prova' : 'les següents proves'}. Treu-la d'aquestes proves per poder-la eliminar:
                            </p>
                            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                                {bundlesUsing
                                    .sort((a, b) => a.nom.localeCompare(b.nom))
                                    .map(bundle => (
                                        <MiniBundle key={bundle.id} bundle={bundle} part={bundle.part} />
                                    ))
                                }
                            </div>
                        </div>
                        <div className="editor-modal-footer">
                            <button
                                className="editor-modal-btn editor-modal-btn-confirm"
                                onClick={() => setShowBlockedModal(false)}
                            >
                                Entesos
                            </button>
                        </div>
                    </div>
                </div>,
                document.body
            ) : null}
        </tr>
    );
}

export default PlantillaRow;
